import http from '@/utils/http'

const create = () => http()
  .post(`/pauses`)

const cancel = () => http()
  .delete(`/pauses`)

export default {
  create,
  cancel
}



// WEBPACK FOOTER //
// ./src/api/pause.js